import { Flex, Text } from '@chakra-ui/react';
import { size } from 'lodash/fp';
import { ImgUploaded } from './ImgUploaded.tsx';
import { ImgUpload } from './ImgUpload.tsx';

export default function Imgs({ images, setImages }: any) {
  const { t } = useTranslation();

  return (
    <>
      <Flex h={'36px'} alignItems={'center'}>
        <Text fontWeight={500} color="grey.95">
          {t('addImg')} ({images?.length} / 3)
        </Text>
      </Flex>
      <Flex gap={2}>
        {images?.map((item, index) => (
          <ImgUploaded
            key={`${index}`}
            imgUrl={item}
            onDel={() => setImages((prev) => prev?.filter((_, idx) => idx !== index))}
          />
        ))}

        {images?.length < 3 ? (
          <ImgUpload
            imgLen={size(images)}
            onAddImg={(url) => setImages((prev) => [...prev, url])}
          />
        ) : null}
      </Flex>
    </>
  );
}
